import { memo } from "react";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ALLOWED_TYPES_DISPLAY } from "@/constants";

interface FilePreviewUnsupportedFormatProps {
  className?: string;
}

export const FilePreviewUnsupportedFormat = memo(
  ({ className }: FilePreviewUnsupportedFormatProps) => {
    const { t } = useTranslation();

    return (
      <div
        className={cn(
          "flex items-center justify-center bg-gray-50 rounded-lg p-8 border border-gray-200 min-h-[200px]",
          className,
        )}
      >
        <div className="text-center">
          <AlertCircle className="h-12 w-12 mx-auto mb-3 text-gray-400" />
          <p className="text-gray-700 font-medium">
            {t("filePreview.unsupportedFormat")}
          </p>
          <p className="text-sm text-gray-500 mt-2">
            {t("filePreview.supportedFormats")}: {ALLOWED_TYPES_DISPLAY}
          </p>
        </div>
      </div>
    );
  },
);
